import React, { useEffect, useState } from 'react';
import { PortalOrigin, Modal } from '../../../ui-kit';
import Loader from '../../../general/Loader';
import axios from 'axios';

// This is a modal for editing announcements. It uses the form rendered by
// Rails because the form is complex and has a lot of validations. It registers
// some global callbacks that are called by the Rails controller using reload.js
// and success.js.erb
const EditAnnouncementModal = ({ groupId, announcementId, onClose, onSuccessfulSave }) => {
  const [html, setHtml] = useState(null);

  const initializeJSComponents = () => {
    setTimeout(() => {
      // fire ajaxComplete on document
      globalThis.jQuery(document).trigger('ajaxComplete');
    }, 0);
  };

  const getAnnouncementFormHTML = async () => {
    let url = `/communication/announcements/${announcementId}/edit?close_button=false&layout=false`;
    if (announcementId == 'new') {
      url = `/groups/${groupId}/communication/announcements/new?&close_button=false&layout=false`;
    }
    const response = await axios.get(url);
    setHtml(response.data);

    // Initialize the JS components like the datepickers
    initializeJSComponents();
  };

  useEffect(() => {
    // store a reference to the succcess callback, which will be called by
    // announcements/success.js.erb. This will then close the modal and refresh
    // the announcement list
    const handleSaveSuccess = event => {
      if (event.detail.id === announcementId || announcementId === 'new') {
        close();
        onSuccessfulSave();
      }
    };

    // if there are validation errors, we need to display the form again using
    // the html passed in the function. See shared/reload.js.erb
    const handleValidationErrors = event => {
      if (event.detail.id === announcementId || announcementId === 'new') {
        setHtml(event.detail.formHtml);
        initializeJSComponents();
      }
    };

    globalThis.inhibitReloadOnAnnouncementSuccess = true;

    document.addEventListener('remote:form:save:success', handleSaveSuccess);
    document.addEventListener('remote:form:validation:errors', handleValidationErrors);

    return () => {
      document.removeEventListener('remote:form:save:success', handleSaveSuccess);
      document.removeEventListener('remote:form:validation:errors', handleValidationErrors);
    };
  }, []);

  useEffect(() => {
    if (announcementId) getAnnouncementFormHTML();
  }, [announcementId]);

  const close = () => {
    onClose();
    setHtml(null);
    globalThis.onAnnouncementSuccess = null;
  };

  // Use the PortalOrigin component to render the modal outside of the widget so
  // it uses the full screen width
  return (
    <PortalOrigin>
      <Modal size="xl" show={true} onHide={close}>
        <Modal.Header closeButton>
          <Modal.Title>
            {announcementId === 'new' && I18n.t('communication.announcements.new')}
            {announcementId !== 'new' && I18n.t('communication.announcements.update')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!html && <Loader />}
          {html && <div dangerouslySetInnerHTML={{ __html: html }} />}
        </Modal.Body>
      </Modal>
    </PortalOrigin>
  );
};

export default EditAnnouncementModal;
